export const LS_DATEFILTER_NAMES = {
    reports: "reportsDateFilter",
    assets: "assetsDateFilter",
    creatives: "creativeDateFilter",
} as const;

export const SS_DATEFILTER_NAMES = {
    campaign: "campaignDateFilter",
} as const;

export const LS_AUTH_SESSION = "authSessionId";

export const LS_CAMPAIGN_DASHBOARD = "campaignDashboardFilters";

export const LS_FILTER_NAMES = {
    reports: {
        campaign: "campaignReportsFilter",
        bundle: "bundleReportsFilter",
        compareMode: "compareModeReportsFilter",
        campaignOptions: "campaignReportsOptions",
    },
} as const;

export const LS_HISTORY_SEARCH = {
    campaigns: "campaignsHistorySearch",
} as const;

export const LS_COLUMN_SETTINGS = {
    columnOrder: "campaignColumnOrder",
    columnVisibility: "campaignColumnVisibility",
} as const;

export const LS_REPORTS_COLUMN_SETTINGS = {
    levels: "reportsColumnLevels",
    metricsGeneral: "reportsColumnMetricsGeneral",
    metricsVideo: "reportsColumnMetricsVideo",
    events: "reportsColumnEvents",
} as const;

export const LS_REPORTS_FILTERS = {
    activeFilters: "reportsActiveFilters",
} as const;

export const LS_REPORTS_PRESETS = {
    savedPresets: "reportsSavedPresets",
    activePresetId: "reportsActivePresetId",
} as const;
